import { Box, Typography, Grid } from '@mui/material';
import HeaderWithBar from './HeaderWithBar';

const Services = () => (
  <Box sx={{ py: {xs: 5, md: 15}, px: {xs:4, md: 20} }}>
    <Box sx={{ display: 'flex', gap: '20px', marginBottom: 5, flexDirection: { xs: 'column', md: 'row' }, }}>
      <Box sx={{ flex: '1 1' }}>
      <HeaderWithBar text="Services" />
      <Typography variant="h3" gutterBottom sx={{ lineHeight: "60px"}} >
        Comprehensive Solutions for Bio Fuel Production
      </Typography>
      </Box>
      <Typography flex='1 1' variant="subtitle1" margin='auto'>
      We specialize in producing high-quality grain-based ethyl alcohol, catering to various industries. Our services extend beyond Bio Fuel production to include dry distilled grain soluble and animal feed, ensuring a holistic approach to grain utilization. We also offer liquid and dry CO2 solutions, enhancing our commitment to sustainability and innovation.
      </Typography>
    </Box>
    <Grid container spacing={8}>
      {[
        { title: 'Bio Fuel Production and Supply Services', icon: 'fluent:animal-paw-print-48-regular', desc: 'We provide reliable and efficient Bio Fuel production services tailored to your needs.' },
        { title: 'Animal Feed and Nutritional Solutions', icon: 'fluent:gas-pump-20-regular', desc: 'Our animal feed products are designed for optimal livestock health.' },
        { title: 'Sustainable CO2 Solutions for Various Applications', icon: 'arcticons:emoji-bubbles', desc: 'We offer both liquid and dry CO2 for diverse industrial uses.' },
      ].map((service, index) => (
        <Grid item xs={12} md={4} key={index} sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: { xs: 'row', md: 'column' }, gap: {xs:2, md: 0} }}>
          <iconify-icon icon={service.icon} width="60" height="60" style={{color: "#6D9A5B", strokeWidth: 2, padding: 3, marginBottom: "8px"}}></iconify-icon>
          <Box >
          <Typography variant="h5" lineHeight="40px" fontWeight="bold" sx={{ fontSize: {xs: "1.05rem", md: '1.25rem'}}} gutterBottom>{service.title}</Typography>
          <Typography variant="subtitle1">{service.desc}</Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default Services;
